import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 152px;
  height: 82px;
  margin-bottom: 10px;
  //grid
  position: relative;
  user-select: none;
`;

export const Tablet = styled.div`
  width: 152px;
  height: 83px;
  box-shadow: inset 0 0 10px 5px rgba(0, 0, 0, 0.5);
  background-color: rgba(0, 0, 0, 0.5);
  margin-top: 10px;
  --grid: rgba(255, 255, 255, 0.1);
  //grid
  background-color: #223144;
  border-radius: 10px;
  position: relative;
`;

export const Text = styled.div`
  text-transform: uppercase;
  text-align: center;
  pointer-events: none;
  line-height: 83px;
  font-weight: bold;
  font-size: 30px;
  opacity: 0.06;
`;

export const Line = styled.div`
  position: absolute;
  background-color: #ffc0cb17;

  &.horizontal {
    left: 0;
    top: calc(50% - 1px);
    right: 0;
    height: 2px;
  }
  &.vertical {
    left: calc(50% - 1px);
    top: 0;
    bottom: 0;
    width: 2px;
  }
`;

export const Header = styled.div`
  position: absolute;
  bottom: -25px;
  right: 0;
  color: #ffffff83;
  font-size: 12px;
  font-weight: bold;
  background-color: #000000;
  padding: 2px 10px;
  border-radius: 10px;
  user-select: none;
  cursor: pointer;

  &:hover {
    background-color: palevioletred;
  }
`;

export const Handle = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #ff29a8;
  border-radius: 30%;
  top: 4px;
  left: 4px;
`;

export const Reset = styled(Header)`
  left: 0;
  width: 50px;
  background-color: transparent;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
`;
